import { render, staticRenderFns } from "./ComplexSettings.vue?vue&type=template&id=51dc82fd"
import script from "./ComplexSettings.vue?vue&type=script&lang=js"
export * from "./ComplexSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports